module.exports = __webpack_public_path__ + "1b5acf155ab56b1610c0f68206e424ea.svg";